import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface SuccessViewProps {
  tierName: string;
  reference: string;
  onReset: () => void;
}
export function SuccessView({
  tierName,
  reference,
  onReset
}: SuccessViewProps) {
  return <div className="min-h-screen bg-forest flex items-center justify-center p-6" data-id="element-155">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-xl w-full bg-cream p-8 sm:p-12 text-center relative overflow-hidden" data-id="element-156">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gold" data-id="element-157" />
        <div className="absolute -top-12 -right-12 w-32 h-32 bg-sage/10 rounded-full blur-2xl" data-id="element-158" />
        <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-sage/10 rounded-full blur-2xl" data-id="element-159" />

        <div className="relative z-10" data-id="element-160">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.3,
          type: 'spring',
          stiffness: 200
        }} className="w-20 h-20 bg-forest text-cream rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-161">
            <CheckIcon size={40} data-id="element-162" />
          </motion.div>

          <h1 className="font-serif text-4xl sm:text-5xl text-forest mb-4" data-id="element-163">
            Welcome to The Salon.
          </h1>

          <p className="text-charcoal-light text-lg mb-8 max-w-md mx-auto" data-id="element-164">
            Your membership for the{' '}
            <strong className="text-forest font-medium" data-id="element-165">{tierName}</strong> tier
            has been confirmed. We are thrilled to have you join our community
            of sustainability leaders.
          </p>

          <div className="bg-cream-dark/50 p-4 border border-sage/20 mb-10 inline-block text-left" data-id="element-166">
            <p className="text-xs text-charcoal-light uppercase tracking-wider mb-1" data-id="element-167">
              Transaction Reference
            </p>
            <p className="font-mono text-sm text-charcoal" data-id="element-168">{reference}</p>
          </div>

          <div data-id="element-169">
            <p className="text-sm text-charcoal-light mb-6" data-id="element-170">
              Check your inbox shortly for your onboarding details and access to
              the member platform.
            </p>
            <button onClick={onReset} className="inline-flex items-center gap-2 text-forest font-medium hover:text-gold transition-colors border-b border-forest hover:border-gold pb-1" data-id="element-171">
              Return to Homepage
              <ArrowRightIcon size={16} data-id="element-172" />
            </button>
          </div>
        </div>
      </motion.div>
    </div>;
}